class HXForm {

    static HXFORM_NAME_DEFAULT = 'f';
    /** @private */
    formName = null;
    /** @private */
    formVars = {};

    /**
     * @param {string} formName
     */
    constructor(formName) {
        this.formName = formName;
        if (this.formName===null || this.formName===undefined) this.formName = HXForm.HXFORM_NAME_DEFAULT;
        if (document.forms[this.formName]===undefined) this.formName = null;

        var tmpVar = window["\$hxFormVar"+this.formName];
        this.formVars = {
            root                        : (tmpVar.hasOwnProperty("root")===true)                        ? tmpVar.root : "",
            dictOptionalMsg             : (tmpVar.hasOwnProperty("dictOptionalMsg")===true)             ? hx.replace(tmpVar.dictOptionalMsg, "\\n", "\n") : "no dicttext",
            dictDecimalplacesMaxMsg     : (tmpVar.hasOwnProperty("dictDecimalplacesMaxMsg")===true)     ? hx.replace(tmpVar.dictDecimalplacesMaxMsg, "\\n", "\n") : "no dicttext",
            dictLimitMsg                : (tmpVar.hasOwnProperty("dictLimitMsg")===true)                ? hx.replace(tmpVar.dictLimitMsg,    "\\n", "\n")    : "no dicttext",
            dictFormatMsg               : (tmpVar.hasOwnProperty("dictFormatMsg")===true)               ? hx.replace(tmpVar.dictFormatMsg,   "\\n", "\n")   : "no dicttext",
            dictLengthMsg               : (tmpVar.hasOwnProperty("dictLengthMsg")===true)               ? hx.replace(tmpVar.dictLengthMsg,   "\\n", "\n")   : "no dicttext",
            dictExtMsg                  : (tmpVar.hasOwnProperty("dictExtMsg")===true)                  ? hx.replace(tmpVar.dictExtMsg,      "\\n", "\n")      : "no dicttext",
            dictDateRangeMin            : (tmpVar.hasOwnProperty("dictDateRangeMin")===true)            ? hx.replace(tmpVar.dictDateRangeMin, "\\n", "\n")      : "no dicttext",
            dictDateRangeMax            : (tmpVar.hasOwnProperty("dictDateRangeMax")===true)            ? hx.replace(tmpVar.dictDateRangeMax, "\\n", "\n")      : "no dicttext",
            dictDateRangeMinAndMax      : (tmpVar.hasOwnProperty("dictDateRangeMinAndMax")===true)      ? hx.replace(tmpVar.dictDateRangeMinAndMax, "\\n", "\n")      : "no dicttext",
            dictUploadBigBrowserOld     : (tmpVar.hasOwnProperty("dictUploadBigBrowserOld")===true)     ? hx.replace(tmpVar.dictUploadBigBrowserOld,"\\n", "\n")      : "no dicttext",
            dictUploadBigOptionalMsg    : (tmpVar.hasOwnProperty("dictUploadBigOptionalMsg")===true)    ? hx.replace(tmpVar.dictUploadBigOptionalMsg,"\\n", "\n")      : "no dicttext",
            dictUploadBigZuVieleUploads : (tmpVar.hasOwnProperty("dictUploadBigZuVieleUploads")===true) ? hx.replace(tmpVar.dictUploadBigZuVieleUploads,"\\n", "\n")      : "no dicttext",
            dictUploadBigFileSize       : (tmpVar.hasOwnProperty("dictUploadBigFileSize")===true)       ? hx.replace(tmpVar.dictUploadBigFileSize,"\\n", "\n")      : "no dicttext",
            dictUploadBigFileExtension  : (tmpVar.hasOwnProperty("dictUploadBigFileExtension")===true)  ? hx.replace(tmpVar.dictUploadBigFileExtension,"\\n", "\n")      : "no dicttext",
            dictUploadBigAnzNeueDateien : (tmpVar.hasOwnProperty("dictUploadBigAnzNeueDateien")===true) ? hx.replace(tmpVar.dictUploadBigAnzNeueDateien,"\\n", "\n")      : "no dicttext",
            dictUploadBigLoeschen       : (tmpVar.hasOwnProperty("dictUploadBigLoeschen")===true)       ? hx.replace(tmpVar.dictUploadBigLoeschen,"\\n", "\n")      : "no dicttext",
            dictKw                      : (tmpVar.hasOwnProperty("dictKw")===true)                      ? hx.replace(tmpVar.dictKw, "\\n", "\n")      : "no dicttext"
        };
        for(let n=1; n <= 12; n++) {
            this.formVars["dictMonat"+n] = (tmpVar.hasOwnProperty("dictMonat"+n)===true) ? hx.replace(tmpVar["dictMonat"+n], "\\n", "\n")      : "no dicttext";
        }
        for(let n = 1; n <= 7; n++) {
            this.formVars["dictWochentag"+n] = (tmpVar.hasOwnProperty("dictWochentag"+n)===true) ? hx.replace(tmpVar["dictWochentag"+n], "\\n", "\n")      : "no dicttext";
        }
    }

    /**
     * @return {array} formVars
     */
    getFormVars(){
        return this.formVars;
    }


    /**
     * HxFormFieldMultiUploadBig
     * @returns {boolean}
     */
    getUploadFieldCount(){
        //Nur Uploadfelder innerhalb der aktuellen Form zaehlen
        return $("form[name='"+this.formName+"'] .hx-formfield-multiupload").length;
    }

    /**
     * @returns {boolean}
     */
    getUploadFileCountNew(){
        var newFiles = 0;
        if (this.getUploadFieldCount() > 0) {
            //Todo via HXFormFieldMultiUploadBig abfregen
            newFiles = $('.hx-formfield-multiupload').find('ul.js-new-files li').length;
        }
        return newFiles;
    }

    /**
     * Uploads starten
     */
    startUpload(){
        hx.guiOverlayOpen($('#hx-formfield-multiupload-overlay').get(0));
        $('[name="start-upload"]').trigger('startupload');

        //W�hrend dem Upload alle Tasten- und Mausaktionen blockieren
        $(document).on("keydown mousedown", (event) => {
            event.preventDefault();
        });
    }

    /**
     * Initialisierung des JQuery FileUpload Pluginq
     */
    initFileuploader() {
            var totalFiles = 0;
            var uploadedFinishedFiles = 0;

            if (this.formName!==null) {
                $("form[name='" + this.formName + "']").fileupload({

                    sequentialUploads: true,

                    //chunks 5MB
                    maxChunkSize: 5000000,

                    // This element will accept file drag/drop uploading
                    dropZone: $(".js-drop-zone"),
                    url: this.formVars.root + "libhx/ajax/form/hxformfieldmultiuploadbig_upload.php",

                    // This function is called when a file is added to the queue;
                    // either via the browse button, or via drag/drop:
                    add: (event, data) => {
                        if (!data.fileInput) {
                            //Wenn Drag and Drop benutzt wurde
                            var currentTarget = $(event.currentTarget);
                            if (currentTarget.hasClass("js-drop-zone")) currentTarget = currentTarget.parent();
                        } else {
                            //Wenn Datei Oeffnen Dialog benutzt wurde
                            var tokenValue = $(data.fileInput[0]).attr("data-token");
                            currentTarget = $("input[value='"+tokenValue+"']").parent();
                        }
                        var fieldname = currentTarget.attr("data-fieldname");
                        //console.log(this.formName+' '+fieldname+' '+$("form[name='"+this.formName+"'] div.hx-formfield-multiupload[data-fieldname='"+fieldname+"'").length);
                        new HXFormFieldMultiUploadBig(fieldname,this.formName).addFile(data);
                    },

                    progress: function (e, data) {
                        data.context.addClass("js-started");
                        var progress = parseInt(data.loaded / data.total * 100, 10);
                        var overlay = $("#hx-formfield-multiupload-overlay");

                        overlay.find(".js-current-file-info").html(data.context.find(".js-filename").html());

                        if (progress == 100) data.context.addClass("js-finished").removeClass("js-started");
                    },

                    progressall: function (e, data) {
                        var dataTotal = data.total;
                        var dataLoaded = data.loaded;
                        totalFiles = $("ul.js-new-files li").length;
                        var finishedFiles = $("ul.js-new-files li.js-finished").length;
                        var startedFiles = $("ul.js-new-files li.js-started").length;

                        var progress = parseInt(data.loaded / data.total * 100, 10);
                        var progressFloat2Komma = hx.formatPreis((data.loaded / data.total * 100), 2);

                        var overlay = $("#hx-formfield-multiupload-overlay");

                        overlay.find(".js-files-info").html((finishedFiles + startedFiles) + "/" + totalFiles);
                        overlay.find(".js-progress-info-done").html(hx.formatByteSize(dataLoaded, 2));
                        overlay.find(".js-progress-info-all").html(hx.formatByteSize(dataTotal, 2));
                        overlay.find(".js-progress-bar").css("width", progress + "%");
                        overlay.find(".js-progress-prozent").html(progressFloat2Komma + "%");
                    },

                    done: (e, data) => {
                        uploadedFinishedFiles++;
                        if (uploadedFinishedFiles >= totalFiles) {
                            setTimeout( () => {
                                var formObj = $("form[name='" + this.formName + "']");
                                var action = formObj.data("action");
                                if (action == 2) {
                                    $("<input>").attr({
                                        type: "hidden",
                                        name: "formbutton_apply",
                                        value: "pressed"
                                    }).appendTo(formObj);
                                }

                                formObj.trigger("submit");
                            }, 500);
                        }
                    },

                    fail: function (e, data) {
                        // Something has gone wrong!
                        data.context.addClass("error");
                    },
                });

            }
    }


    displayInit() {

        if (this.getUploadFieldCount()>0) {
            this.initFileuploader();

            // Prevent the default action when a file is dropped on the window
            $(document).on("drop dragover", (event) => {
                event.preventDefault();
            });

        }

        $("form[name='"+this.formName+"']").on("click", '.formsubmit',(event) => {
            var action = 1;
            var $formObj = $("form[name='" + this.formName + "']");
            if($(event.currentTarget).hasClass("formbuttonApply")) action = 2;
            $formObj.data('action', action);
            $(".js-input_button_click").val($(event.currentTarget).attr("name"));

            if(beforesubmit()){
                if($(event.currentTarget).hasClass("formbuttonApply")){
                    $('<input>').attr({
                        type:"hidden",
                        name:"formbutton_apply",
                        value:"pressed"
                    }).appendTo("form[name="+this.formName+"]");
                }
                $(".formbutton").prop("disabled", true);
                $formObj.trigger("submit");
            }
        });

    }
}